import React, { useEffect, useRef } from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSquare, faSquareCheck } from '@fortawesome/free-regular-svg-icons';

import { Multiselect } from 'multiselect-react-dropdown';

import { trackStatsFilter } from '../../services/eventTracking';

const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  min-width: 20em;
  min-height: 7.5em;
  border: 1px dashed #aaa;
  padding: 1em;
  font-size: 0.7em;

  & .chip {
    border-radius: 1px;
    padding: 2px;
    max-width: 100%;
    background-color: #228fd8;
  }

  & .highlightOption, .multiSelectContainer li:hover {
    background-color: #228fd8;
  }

  & .searchBox {
    color: #999;
    font-size: .8rem;
  }

  & .searchWrapper {
    border: 1px solid #aaa;
    border-radius: 2px;
    min-height: 32px;
  }

  & .icon_cancel {
    margin-left: 1px;
  }

  > div > div > div {
    border-radius: 2px;
  }
`;

const FilterContainer = styled.div`
  flex: 1;
  max-width: ${(props) => (props.$maxWidth ? props.$maxWidth : '12em')};
  margin: 5px;

  > div > div {
    padding: 0;
  }

  > div > div > span {
    min-height: 22px;
    color: #777;
    margin-bottom: 0;
    font-size: 1em;
  }

  & .chip {
    padding: 9px 7px 6px 7px;
  }
`;

const FilterContainerSingleSelect = styled.div`
  flex: 1;
  max-width: ${(props) => (props.$maxWidth ? props.$maxWidth : '12em')};
  margin: 5px;

  > div > div > div {
    padding: 0;
  }

  > div > div > div > span {
    color: #777;
    margin-bottom: 0;
    font-size: 1em;
  }

  > div > div > div > span > img {
    display: none;
  }

  > div > div > div > input {
    display: none;
  }

  & .chip {
    padding: 7px 7px 4px 7px;
    background-color: white;
    font-size: .8rem;
  }
`;

/*
const IGLsFilter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 .25rem;
  height: 30px;
  width: 6em;
  border: 1px solid #aaa;
  border-radius: 2px;
  padding: 0 .75em;
  color: #777;
  text-align: center;
  font-size: .8rem;
  cursor: default;
  ${props => props.$active && 'background-color: #666; color: white;'}

  > svg {
    margin-right: .3em;
    font-size: .8rem;
  }
`;
*/

const Reset = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 .25rem;
  height: 30px;
  width: 6em;
  border: 1px solid #aaa;
  border-radius: 4px;
  padding: 0 .75em;
  background-color: #228fd8;
  color: white;
  font-size: .9rem;
  text-align: center;
`;

const ResetOverlay = styled.div`
  z-index: 100;
  margin-left: -6.75em;
  height: 100%;
  min-width: 6em;
  padding: .25em .75em;
  opacity: 0;
  cursor: pointer;
`;

/*
const statsFiltersRoleOptions = [
  'Duelist',
  'Initiator',
  'Controller',
  'Sentinel',
  'Flex'
];
*/

const statsFiltersRegionOptions = [
  'Americas',
  'EMEA',
  'Pacific',
  // 'China'
];

const playerRankingsTierFilterOptions = [
  { tier: 'any', label: 'Any Tier', id: 'any' },
  { tier: 'global', label: 'VCT', id: 'global' },
  { tier: 'challengers', label: 'Challengers', id: 'challengers' },
  { tier: 'tier2Plus', label: 'VCT+Chall', id: 'tier2Plus' },
  { tier: 'regionals', label: 'Tier 3', id: 'regionals' }
];

const minRoundsFilterOptions = [
  { rounds: 0, label: '1+ Rds', id: '1+ Rds' },
  { rounds: 50, label: '50+ Rds', id: '50+ Rds' },
  { rounds: 100, label: '100+ Rds', id: '100+ Rds' },
  { rounds: 150, label: '150+ Rds', id: '150+ Rds' }
];

const yearFilterOptions = [];
const startYear = new Date().getFullYear();
const endYear = 2023;
for (let year = startYear; year >= endYear; year--) {
  yearFilterOptions.push({
    year: year, label: year, id: year
  })
}

const StatsFilters = ({ AppStore, view, statsType }) => {
  const yearRef = useRef(null);
  const regionRef = useRef(null);
  const teamRef = useRef(null);
  // const roleRef = useRef(null);
  const tierRef = useRef(null);
  const minRoundsRef = useRef(null);
  const mapFilterRef = useRef(null);
  const agentFilterRef = useRef(null);

  const mapsFetched = AppStore.statsFiltersMapOptions.length > 0;
  const mapsFetching = AppStore.statsFiltersMapOptionsFetching.get();

  const agentsFetched = AppStore.statsFiltersAgentOptions.length > 0;
  const agentsFetching = AppStore.statsFiltersAgentOptionsFetching.get();

  const filtersNeedReset = AppStore.statsFiltersNeedReset.get();

  const handleFilterSubmit = () => {
    AppStore.filterStats(view);
  };

  const onChangeYear = (selectedList, selectedItem) => {
    AppStore.setStatsFilterValue("year", selectedItem);
    handleFilterSubmit();
    trackStatsFilter("selectYear", selectedItem.year);
  };

  const onRegionSelect = (selectedList, selectedItem) => {
    if (!AppStore.statsFilters.regions) {
      AppStore.setStatsFilterValue("regions", [selectedItem.region]);
    } else {
      AppStore.statsFilters.regions.push(selectedItem.region);
    }
    handleFilterSubmit();
    trackStatsFilter("selectRegion", selectedItem.region);
  };
  const onRegionRemove = (selectedList, removedItem) => {
    let indexToRemove = AppStore.statsFilters.regions.indexOf(removedItem.region);
    AppStore.statsFilters.regions.splice(indexToRemove, 1);
    handleFilterSubmit();
    trackStatsFilter("removeRegion", removedItem.region);
  };

  const onTeamSelect = (selectedList, selectedItem) => {
    if (!AppStore.statsFilters.teams) {
      AppStore.setStatsFilterValue("teams", [selectedItem.team]);
    } else {
      AppStore.statsFilters.teams.push(selectedItem.team);
    }
    handleFilterSubmit();
    trackStatsFilter("selectTeam", selectedItem.team);
  };
  const onTeamRemove = (selectedList, removedItem) => {
    let indexToRemove = AppStore.statsFilters.teams.indexOf(removedItem.team);
    AppStore.statsFilters.teams.splice(indexToRemove, 1);
    handleFilterSubmit();
    trackStatsFilter("removeTeam", removedItem.team);
  };

  /*
  const onRoleSelect = (selectedList, selectedItem) => {
    if (!AppStore.statsFilters.roles) {
      AppStore.statsFilters.roles = [selectedItem.role];
    } else {
      AppStore.statsFilters.roles.push(selectedItem.role);
    }
    handleFilterSubmit();
    trackStatsFilter("selectRole", selectedItem.role);
  };
  const onRoleRemove = (selectedList, removedItem) => {
    let indexToRemove = AppStore.statsFilters.roles.indexOf(removedItem.role);
    AppStore.statsFilters.roles.splice(indexToRemove, 1);
    handleFilterSubmit();
    trackStatsFilter("removeRole", removedItem.role);
  };

  const onChangeIglFilter = (event) => {
    event.preventDefault();
    AppStore.togglePlayerRankingsIglFilter();
    handleFilterSubmit();
    trackStatsFilter("toggleIgl", 'toggle');
  };
  */

  const onChangeTier = (selectedList, selectedItem) => {
    AppStore.setStatsFilterValue("tier", selectedItem);
    handleFilterSubmit();
    trackStatsFilter("selectTier", selectedItem.tier);
  };

  const onChangeMinRounds = (selectedList, selectedItem) => {
    AppStore.setStatsFilterValue("minRounds", selectedItem);
    handleFilterSubmit();
    trackStatsFilter("selectMinRounds", selectedItem.rounds);
  };

  const onChangeMapFilter = (selectedList, selectedItem) => {
    AppStore.setStatsFiltersChanged(true);
    AppStore.setStatsFilterValue("map", selectedItem);
    handleFilterSubmit();
    trackStatsFilter("selectMapFilter", selectedItem.name);
  };

  const onChangeAgentFilter = (selectedList, selectedItem) => {
    AppStore.setStatsFiltersChanged(true);
    AppStore.setStatsFilterValue("agent", selectedItem);
    handleFilterSubmit();
    trackStatsFilter("selectAgentFilter", selectedItem.name);
  };

  const resetFilters = (event) => {
    if (event) {
      event.preventDefault();
    }
    if (view === 'playerRankings') {
      yearRef.current.onSelectItem(yearFilterOptions[0]);
      tierRef.current.onSelectItem({ tier: 'tier2Plus', label: 'VCT+Chall', id: 'tier2Plus' });
      minRoundsRef.current.onSelectItem({ rounds: 100, label: '100+ Rds', id: '100+ Rds' });
      regionRef.current &&
        regionRef.current.hasOwnProperty('resetSelectedValues') &&
        regionRef.current.resetSelectedValues();
      AppStore.statsFilters.regions = [];
      // AppStore.resetPlayerRankingsIglAndTargetFilters();
    }
    if (view === 'stats') {
      minRoundsRef.current.onSelectItem({ rounds: 0, label: '1+ Rds', id: '1+ Rds' });
      mapFilterRef.current.onSelectItem({ id: null, 'name': 'All Maps' });
      if (statsType === 'players') {
        agentFilterRef.current.onSelectItem({ id: null, 'name': 'All Agents' });
      }
    }
    teamRef.current &&
      teamRef.current.hasOwnProperty('resetSelectedValues') &&
      teamRef.current.resetSelectedValues();
    AppStore.statsFilters.teams = [];
    /* roleRef.current &&
      roleRef.current.hasOwnProperty('resetSelectedValues') &&
      roleRef.current.resetSelectedValues();
    AppStore.statsFilters.roles = []; */

    handleFilterSubmit();
    AppStore.setStatsFiltersNeedReset(false);
  };

  useEffect(() => {
    if (!mapsFetched && !mapsFetching) {
      AppStore.setMapFilterOptions();
    }

    if (!agentsFetched && !agentsFetching) {
      AppStore.setAgentFilterOptions();
    }

    if (filtersNeedReset) {
      resetFilters();
    }
  }, [
    AppStore,
    AppStore.statsFilters,
    mapsFetched,
    mapsFetching,
    agentsFetched,
    agentsFetching,
    filtersNeedReset
  ]);

  return (
    <FiltersWrapper>
      {view === 'playerRankings' && (
        <>
          <FilterContainerSingleSelect>
            <Multiselect
              id='yearFilter'
              options={yearFilterOptions}
              singleSelect={true}
              selectedValues={[AppStore.statsFilters.year]}
              placeholder={'Year'}
              onSelect={onChangeYear}
              onRemove={onChangeYear}
              closeIcon='cancel'
              closeOnSelect={true}
              displayValue='label'
              ref={yearRef}
            />
          </FilterContainerSingleSelect>
          <FilterContainer>
            <Multiselect
              id='regionFilter'
              options={statsFiltersRegionOptions.map((region) => {
                return { region: region, id: region };
              })}
              placeholder={'Filter Regions'}
              // hidePlaceholder={true}
              onSelect={onRegionSelect}
              onRemove={onRegionRemove}
              closeIcon='cancel'
              displayValue='region'
              avoidHighlightFirstOption={true}
              ref={regionRef}
            />
          </FilterContainer>
        </>
      )}
      <FilterContainer $maxWidth='18em'>
        <Multiselect
          id='teamFilter'
          options={AppStore.statsFiltersTeamOptions.map((team) => {
            team = team ? team : '-';
            return { team: team, id: team };
          })}
          placeholder={'Filter Teams'}
          // hidePlaceholder={true}
          onSelect={onTeamSelect}
          onRemove={onTeamRemove}
          closeIcon='cancel'
          displayValue='team'
          avoidHighlightFirstOption={true}
          ref={teamRef}
        />
      </FilterContainer>
      {view === 'playerRankings' && (
        <>
          {/* <FilterContainer>
            <Multiselect
              id='roleFilter'
              options={statsFiltersRoleOptions.map((role) => {
                return { role: role, id: role };
              })}
              placeholder={'Filter Roles'}
              // hidePlaceholder={true}
              onSelect={onRoleSelect}
              onRemove={onRoleRemove}
              closeIcon='cancel'
              displayValue='role'
              avoidHighlightFirstOption={true}
              ref={roleRef}
            />
          </FilterContainer> */}
          <FilterContainerSingleSelect>
            <Multiselect
              id='tierFilter'
              options={playerRankingsTierFilterOptions}
              singleSelect={true}
              selectedValues={[AppStore.statsFilters.tier]}
              placeholder={'Tier'}
              onSelect={onChangeTier}
              onRemove={onChangeTier}
              closeIcon='cancel'
              closeOnSelect={true}
              displayValue='label'
              ref={tierRef}
            />
          </FilterContainerSingleSelect>
        </>
      )}
      {view === 'stats' && statsType === 'players' && (
        <FilterContainerSingleSelect>
          <Multiselect
            id='agentFilter'
            options={AppStore.statsFiltersAgentOptions.map((agent) => {
              return { name: agent.name, id: agent.id };
            })}
            singleSelect={true}
            selectedValues={[AppStore.statsFilters.agent]}
            onSelect={onChangeAgentFilter}
            onRemove={onChangeAgentFilter}
            closeIcon='cancel'
            closeOnSelect={true}
            displayValue='name'
            ref={agentFilterRef}
          />
        </FilterContainerSingleSelect>
      )}
      {view === 'stats' && (
        <FilterContainerSingleSelect>
          <Multiselect
            id='mapFilter'
            options={AppStore.statsFiltersMapOptions.map((map) => {
              return { name: map.name, id: map.id };
            })}
            singleSelect={true}
            selectedValues={[AppStore.statsFilters.map]}
            onSelect={onChangeMapFilter}
            onRemove={onChangeMapFilter}
            closeIcon='cancel'
            closeOnSelect={true}
            displayValue='name'
            ref={mapFilterRef}
          />
        </FilterContainerSingleSelect>
      )}
      <FilterContainerSingleSelect>
        <Multiselect
          id='minRoundsFilter'
          options={minRoundsFilterOptions}
          singleSelect={true}
          selectedValues={[view === 'playerRankings' ? AppStore.statsFilters.minRoundsPlayerRankings : AppStore.statsFilters.minRounds]}
          placeholder={'Min. Rds'}
          onSelect={onChangeMinRounds}
          onRemove={onChangeMinRounds}
          closeIcon='cancel'
          closeOnSelect={true}
          displayValue='label'
          ref={minRoundsRef}
        />
      </FilterContainerSingleSelect>
      {/* view === 'playerRankings' && (
        <>
          <IGLsFilter
            onClick={onChangeIglFilter}
            $active={AppStore.statsFilters.iglFilterActive}
          >
            <FontAwesomeIcon
              icon={AppStore.statsFilters.iglFilterActive ? faSquareCheck : faSquare}
            />
            IGLs only
          </IGLsFilter>
        </>
      ) */}
      <Reset onClick={resetFilters}>
        <div style={{ 'minWidth': '6em' }}>Reset Filters</div>
        <ResetOverlay />
      </Reset>
    </FiltersWrapper>
  );
};

export default inject('AppStore')(observer(StatsFilters));
